import React from 'react'
import PropTypes from 'prop-types'
import { MEDIA_HEIGHT, MEDIA_WIDTH } from '../../../../fields'

const DimensionsSectionPreview = ({ ad }) => {
  return (
    <>
      <div>Width: {ad.dimensions[MEDIA_WIDTH]}</div>
      <div>Height: {ad.dimensions[MEDIA_HEIGHT]}</div>
    </>
  )
}

DimensionsSectionPreview.propTypes = {
  ad: PropTypes.object
}

export default DimensionsSectionPreview
